<template>
    <div class="cmp-address-validator td-form">
        <input type="text" :value="modelValue" @input="updateAddress" :placeholder="placeholder" :class="{'error' : validationFailed}" @keydown.enter="sendLoginValidationCode" ref="username" />
        <div v-if="!disableValidation && !isValidated">
            <div v-if="addressCodeHasBeenSent">
                <div class="td-banner success slim mb-3">
                    <icon class="icon" type="solid" name="faCheck" aria-hidden="true"></icon>
                    <p>{{ addressSentMessage }}</p>
                </div>
                <div class="code-container">
                    <input id="code-digit-1"
                           type="text"
                           inputmode="numeric"
                           :value="addressValidationCode1"
                           ref="code1" maxlength="6"
                           placeholder=""
                           @keydown="handleKeyPress(1, $event)"
                           @input="event => setCodeValue(1, event.target.value)" />
                    <input id="code-digit-2"
                           type="text"
                           inputmode="numeric"
                           :value="addressValidationCode2" ref="code2"
                           maxlength="1"
                           placeholder=""
                           @keydown="handleKeyPress(2, $event)"
                           @input="event => setCodeValue(2, event.target.value)" />
                    <input id="code-digit-3"
                           type="text"
                           inputmode="numeric"
                           :value="addressValidationCode3"
                           ref="code3" maxlength="1" placeholder=""
                           @keydown="handleKeyPress(3, $event)"
                           @input="event => setCodeValue(3, event.target.value)" />
                    <input id="code-digit-4"
                           type="text"
                           inputmode="numeric"
                           :value="addressValidationCode4"
                           ref="code4" maxlength="1"
                           placeholder=""
                           @keydown="handleKeyPress(4, $event)"
                           @input="event => setCodeValue(4, event.target.value)" />
                    <input id="code-digit-5"
                           type="text"
                           inputmode="numeric"
                           :value="addressValidationCode5"
                           ref="code5"
                           maxlength="1"
                           placeholder=""
                           @keydown="handleKeyPress(5, $event)"
                           @input="event => setCodeValue(5, event.target.value)" />
                    <input id="code-digit-6"
                           type="text"
                           inputmode="numeric"
                           :value="addressValidationCode6"
                           ref="code6"
                           maxlength="1"
                           placeholder=""
                           @keydown="handleKeyPress(6, $event)"
                           @input="event => setCodeValue(6, event.target.value)" />
                </div>
            </div>
            <div class="td-banner danger slim" v-if="errorMessage.length > 0">
                <icon class="icon" type="solid" name="faTriangleExclamation" aria-hidden="true"></icon>
                <div> {{ errorMessage }}</div>
            </div>
            <a class="td-link td-flex mb-2" v-if="addressCodeHasBeenSent" href="#" @click.prevent="sendLoginValidationCode">Resend code</a>
            <div class="btns-grid">
                <button class="td-btn secondary-outlined with-pass" v-if="!disablePassword && !isLoginWithPassword && !addressCodeHasBeenSent" title="Login with password" @click.prevent="showLoginWithPassword">Login with Password</button>
                <span v-if="disablePassword || isLoginWithPassword || addressCodeHasBeenSent"></span>
                <button class="td-btn primary next-btn" v-if="!addressCodeHasBeenSent" @click="sendLoginValidationCode">
                    <span v-if="!isSendingCode">Continue</span>
                    <span v-else>
                        <icon class="icon" type="solid" name="faSpinner" aria-hidden="true" spin></icon>
                    </span>
                </button>
            </div>

            <div v-if="addressCodeHasBeenSent" class="btns-grid">
                <button class="td-btn secondary-outlined with-pass" v-if="!disablePassword && !isLoginWithPassword" title="Login with password" @click.prevent="showLoginWithPassword">Login with Password</button>
                <span v-if="disablePassword || isLoginWithPassword"></span>
                <button class="td-btn primary td-full-width mt-1" @click="validateCode">
                    <span v-if="!isValidatingCode">Validate</span>
                    <span v-else>
                        <icon class="icon" type="solid" name="faSpinner" aria-hidden="true" spin></icon>
                    </span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>import script from './AddressValidator';
    export default script;</script>

<style lang="less">
    @import "./AddressValidator.less";
</style>
